import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import '../../assets/css/Menu.css';
import CommonMenu from './CommonMenu';
import logo from '../../assets/images/logo.png';
import menuBgGradient from '../../assets/images/home-menu-bg-gradient.png';
import bannerBgPic from '../../assets/images/banner-bg.jpg';


const lang = '';

class MenuHome extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  getLink(page){
    if (page == '') {
      return (this.lang) ? '/' + this.lang : '/' + page;
    } else {
      return (this.lang) ? '/' + this.lang + '/' + page : '/' + page;
    }
  }

  render(){
    return(
      MenuHomeJSX(this)
    );
  }
}

const MenuHomeJSX = (ctx) => (
    <div className="menu-home" style={{ borderBottom:'solid 10px rgb(245,120,42)' }}>
      <div style={{ height:'300pt', background:'url("' + bannerBgPic + '") 60% 0%  no-repeat', backgroundSize:'cover', position:'relative'}}>
        <div style={{ position:'absolute', top:'0', width:'100%', zIndex:'999', backgroundImage:'url("' + menuBgGradient + '")' }}>
          <Grid className="menu-home-container-parent" container>
            <Grid className="menu-home-container" container spacing={0} style={{ height:'80pt', lineHeight:'80pt' }}>
              <Grid className="grid-item-corp-logo-container" item xs={4} sm={4}>
                <Link to={ ctx.getLink('') } style={{ textDecoration: 'none'}}>
                  <img id="corp-logo" src={logo} style={{ display:'inline-block', verticalAlign:'middle' }} />
                </Link>
              </Grid>
              <Grid item xs={8} sm={8}>
                <CommonMenu lang={ ctx.lang } />
              </Grid>
            </Grid>
          </Grid>
        </div>

        <Grid id="menu-home-slogan-container" container style={{ position:'absolute', zIndex:'10' }}>
          <Grid id="menu-home-slogan-container-inner" container item style={{ position:'relative' }}>
            <div id="menu-home-slogan" style={{ position:'relative' }}>
              <div style={{position:'relative', width:'100%', height:'100%', backgroundColor:'rgb(255,255,255)', opacity:'0.2' }}>
              </div>
              <div style={{ position:'absolute', top:'0px', width:'100%', height:'100%', textAlign:'center' }}>
                <div>
                  <h1 style={{color:'rgb(245, 120, 42)', textShadow:'2px 2px 1px rgba(132, 132, 132, 1)', fontWeight:'bold', marginBottom:'10px'}}>
                    {
                      ctx.getLangText({
                        'tc': '專業 誠信 創新 實用',
                        'sc': '专业 诚信 创新 实用',
                        'en': 'Professional, Integrity, Innovation, Practicality'
                      })
                    }
                  </h1>
                </div>
                <div>
                  <span style={{ color:'#FFF', textShadow:'2px 2px 1px rgba(132, 132, 132, 1)' }}>
                    {
                      ctx.getLangText({
                        'tc': '深度結合行業和互聯網技術',
                        'sc': '深度结合行业和互联网技术',
                        'en': 'Highly integrating industry knowledge with internet technology'
                      })
                    }
                  </span>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

      </div>
    </div>
)

export default MenuHome



// WEBPACK FOOTER //
// ./src/components/pages/includes/MenuHome.js